// 動画作成フォーム: 添付ファイルの添付先(uploads[i][filename])選択の状態管理
import { ref, computed } from 'vue';
import _ from 'lodash';

export const useAttachmentTarget = () => {
  const attachmentTargetOptions = ref([]);
  const attachmentTargetFilename = ref('');
  const attachmentCount = ref(0);

  const translate = (key, fallback = null) =>
    _.get(window.i18n, key) || fallback || key;

  // 添付先「自動」選択肢の表示文言。実際に添付される1件(is_auto_target)が
  // 判明していれば、そのファイル名を含めた文言を返す。
  const attachmentTargetAutoLabel = computed(() => {
    const autoTarget = attachmentTargetOptions.value.find((opt) => opt.is_auto_target === true);
    if (autoTarget) {
      return translate('video.attachments_target_auto_named').replace(':name', autoTarget.display_path);
    }
    return translate('video.attachments_target_auto');
  });

  const setAttachmentCount = (count) => {
    attachmentCount.value = Number(count) || 0;
  };

  // 添付先セレクトは「添付ファイルが1件以上あり、かつ添付先候補が存在する」ときだけ出す
  const showAttachmentTargetSelect = computed(
    () => attachmentCount.value > 0 && attachmentTargetOptions.value.length > 0
  );

  const setAttachmentTargetOptions = (list) => {
    attachmentTargetOptions.value = Array.isArray(list) ? list : [];

    // 選択中の filename が新しい選択肢に無い場合のみ「自動」へリセットする
    // (添付先として選んでいた行を、登録に失敗した後に取り除いたときに通る)
    const stillExists = attachmentTargetOptions.value.some(
      (opt) => opt.filename === attachmentTargetFilename.value
    );
    if (attachmentTargetFilename.value !== '' && !stillExists) {
      attachmentTargetFilename.value = '';
    }
  };

  const initAttachmentTarget = () => {
    // #attachments_target_select は v-if="attachmentTargetOptions.length > 0" 配下のため
    // onMounted 時点(初回レンダリング)ではDOMに存在しない。
    // 常時DOMに存在する #attachments_target_old から old 値を取得する。
    const carrier = document.getElementById('attachments_target_old');
    if (!carrier) {
      return;
    }
    const oldValue = carrier.getAttribute('data-old-value');
    if (oldValue) {
      attachmentTargetFilename.value = oldValue;
    }
  };

  return {
    attachmentTargetOptions,
    attachmentTargetFilename,
    attachmentTargetAutoLabel,
    attachmentCount,
    setAttachmentCount,
    showAttachmentTargetSelect,
    setAttachmentTargetOptions,
    initAttachmentTarget,
  };
};
